import { flow, isEmpty, reverse, sortBy } from 'lodash'
import { equals, prop } from 'lodash/fp'
import React, { useMemo } from 'react'
import { getPerformanceIndicatorLabel } from 'scenes/Dashboard/data/performanceIndicators/helpers'
import { PerformanceIndicator, PerformanceIndicatorType } from 'scenes/Dashboard/data/performanceIndicators/types'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import { PerformanceIndicatorView } from './components/PerformanceIndicatorView'

type PerformanceIndicatorsViewByTypeProps = {
  performanceIndicators: PerformanceIndicator[]
  type: PerformanceIndicatorType
  dateFormat?: string
}

export const PerformanceIndicatorsViewByType = React.memo(
  ({ performanceIndicators, type, dateFormat }: PerformanceIndicatorsViewByTypeProps) => {
    const { classes } = useStyles()
    const performanceIndicatorsOfType = useMemo(
      () => performanceIndicators.filter(flow([prop('type'), equals(type)])),
      [performanceIndicators, type]
    )
    if (isEmpty(performanceIndicatorsOfType)) {
      return null
    }
    return (
      <>
        <Typography variant="body2" className={classes.typeLabel}>
          {getPerformanceIndicatorLabel(type)}
        </Typography>
        {reverse(sortBy(performanceIndicatorsOfType, 'measuredOn')).map((performanceIndicator) => (
          <PerformanceIndicatorView
            key={performanceIndicator.id}
            performanceIndicator={performanceIndicator}
            displayLabel={false}
            dateFormat={dateFormat}
          />
        ))}
      </>
    )
  }
)

PerformanceIndicatorsViewByType.displayName = 'PerformanceIndicatorsViewByType'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  typeLabel: {
    fontWeight: 'bold',
    '&:not(:first-child)': {
      marginTop: spacing(2),
    },
  },
}))
